import { useQuery } from "@tanstack/react-query";
import type { Channel } from "@kkp/api-client";
import { getProfile } from "../../api/profile";

export function PaymentDestinationBlock({ channel }: { channel: Channel }) {
  const isBank = channel === "Bank";
  // Same query key Dashboard/Profile use, so this is normally served warm from
  // the React Query cache rather than refetched per dialog open.
  const { data: profile } = useQuery({
    queryKey: ["client-profile"],
    queryFn: getProfile,
    enabled: !isBank,
  });

  const companyName = profile?.companyName?.trim() || "—";
  const vaNumber = profile?.vaNumber?.trim() || "—";

  return (
    <div className="rounded-xl border border-amber-400/40 bg-amber-500/10 p-4">
      <div className="text-[11px] font-semibold uppercase tracking-wider text-amber-200">
        {isBank
          ? "Transfer to this bank account"
          : "Pay this Virtual Account (Payment Funding)"}
      </div>
      <div className="mt-2 grid gap-1">
        <div className="text-xs text-amber-100/80">
          {isBank
            ? "BRI (002) · KCP Harapan Indah Bekasi"
            : "BRI · Bank code 002"}
        </div>
        <div className="font-mono text-2xl font-bold tracking-wider text-amber-50 break-all">
          {isBank ? "0424-01-169169-30-1" : vaNumber}
        </div>
        <div className="text-xs font-semibold text-amber-100">
          {isBank ? "a/n PT. IMMER" : `a/n ${companyName} via PT. IMMER`}
        </div>
      </div>
    </div>
  );
}
